import { jsonProperty, Serializable } from "ts-serializable";
interface IContato {    
    nome: string;
    email: string;
    telefone: string;
    grauParentesco: string;
    emergencia: boolean;
  }
class Person extends Serializable{

    @jsonProperty(String, null)
    id: string | null = null;

    @jsonProperty(String, null)
    cpf: string | null = null;

    @jsonProperty(String, null)
    nome: string | null = null;
    
    @jsonProperty(String, null)
    comoSerChamado: string | null = null;

    @jsonProperty(String, null)
    email: string | null = null;

    @jsonProperty(String, null)
    dataNascimento: string | null = null;

    @jsonProperty([String], null)
    telefones: string[] | null = [];

    @jsonProperty([Object], null)
    contatos: IContato[] | null = [];

    @jsonProperty(String, null)
    solicitacaoRedefinirSenha: boolean = false;

    @jsonProperty(String, null)
    Genero: string | null = null;    

    @jsonProperty(Boolean, null)
    isDependente: boolean = false;

}  

export default Person;